import { useEffect } from "react";
import { useDispatch } from "react-redux";
import CachedItem, { LoadCachedItem } from "../config/cache";
import { setToken, setUser, setUserLoaded } from "../reducers/userReducer";

export default function useLoadCache() {
  const dispatch = useDispatch();

  const loadToken = () => {
    const data = LoadCachedItem(CachedItem.token, true);
    data && dispatch(setToken(data));
  };

  const loadUser = () => {
    const data = LoadCachedItem(CachedItem.user, true);
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        dispatch(setUser(parsedData));
      } catch (error) {
        console.error('Failed to parse cached user data', error);
      }
    }
    dispatch(setUserLoaded(true));
  };

  useEffect(() => {
    loadToken();
    loadUser();
  }, []);

  return undefined;
}
